/* biome-ignore-all lint/suspicious/noExplicitAny: legacy form handling */
import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Space } from "antd"
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons"
import type React from "react"
import type { SpeechAssessmentQueryParams } from "@/services/log/speechAssessmentApi"
import dayjs from "dayjs"

const { RangePicker } = DatePicker

interface SpeechAssessmentFilterFormProps {
  onSearch: (values: SpeechAssessmentQueryParams) => void
  loading?: boolean
  initialValues?: SpeechAssessmentQueryParams
}

export const SpeechAssessmentFilterForm: React.FC<SpeechAssessmentFilterFormProps> = ({
  onSearch,
  loading = false,
  initialValues,
}) => {
  const [form] = Form.useForm()

  const handleFinish = (values: any) => {
    const { dates, ...rest } = values
    const queryParams: SpeechAssessmentQueryParams = {
      ...rest,
      start_date: dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : undefined,
      end_date: dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : undefined,
    }
    onSearch(queryParams)
  }

  const handleReset = () => {
    form.resetFields()
    onSearch({})
  }

  return (
    <Card className="mb-2 shadow-xs">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{
          reference_text: initialValues?.reference_text,
          user_search: initialValues?.user_search,
          status: initialValues?.status,
          score_range: initialValues?.score_range,
          dates:
            initialValues?.start_date && initialValues?.end_date
              ? [dayjs(initialValues.start_date), dayjs(initialValues.end_date)]
              : [dayjs().subtract(7, "day"), dayjs()],
        }}
      >
        <Row gutter={[16, 8]}>
          <Col xs={24} sm={12} md={6} lg={5}>
            <Form.Item label="Thời gian thực hiện" name="dates">
              <RangePicker
                className="w-full"
                placeholder={["Từ ngày", "Đến ngày"]}
                format="DD/MM/YYYY"
                allowClear={false}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={5}>
            <Form.Item label="Từ / câu mẫu (reference_text)" name="reference_text">
              <Input placeholder="Ví dụ: hello, world..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={5}>
            <Form.Item label="Người dùng (Tên, Email, #ID)" name="user_search">
              <Input placeholder="Nhập tên, email hoặc #ID..." allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item label="Trạng thái" name="status">
              <Select
                placeholder="Tất cả trạng thái"
                allowClear
                options={[
                  { label: "Tất cả", value: "" },
                  { label: "Thành công", value: "success" },
                  { label: "Thất bại", value: "failed" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={5}>
            <Form.Item label="Thang điểm phát âm" name="score_range">
              <Select
                placeholder="Tất cả mức điểm"
                allowClear
                options={[
                  { label: "Tất cả", value: "" },
                  { label: "Yếu (< 50)", value: "low" },
                  { label: "Khá (50 - 80)", value: "medium" },
                  { label: "Tốt (> 80)", value: "high" },
                ]}
              />
            </Form.Item>
          </Col>

          <Col xs={24} className="flex justify-end">
            <Space>
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                Đặt lại
              </Button>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />} loading={loading}>
                Tìm kiếm
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default SpeechAssessmentFilterForm
